// extracted by mini-css-extract-plugin
export var checkbox = "_96-0";
export var circle = "_96-3";
export var horizontalContainer = "_96-7";
export var sm = "_96-5";
export var switch0 = "_96-2";
export var switchDisabled = "_96-8";
export var switchEnabled = "_96-1";
export var textSwitchContainer = "_96-9";
export var textSwitchOption = "_96-a";
export var textSwitchOptionSelected = "_96-b";
export var verticalContainer = "_96-6";
export var xs = "_96-4";